export enum SessionKeys {
  CREDIT_NOTE = 'CreditNoteVK',

}
